import { Sector } from '@/domain/impact/impact.entity';

import { projectFestivalSlice } from '../project-festival.slice';

export const setProjectFestivalCurrentSector = (sector: Sector) =>
  projectFestivalSlice.actions.setCurrentSector(sector);
